import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {Http, Response} from '@angular/http';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';
import { Observable } from 'rxjs';
import { IRulesByCodeResponse } from 'app/core/interfaces/rules-by-code.interface';

@Injectable()
export class RulesService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }


  /**
   * @name getRole
   * @description
   */
  getRules() {
    return this._http.get(constant.URL_RULES, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getRole
   * @description
   */
  getRulesAvailableToPayor() {
    return this._http
      .get(constant.URL_RULES_AVAILABLE_TO_PAYOR, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getRoler
   * @description Cargar una sola regla
   */
  getRuler(id) {
    return this._http
      .get(`${constant.URL_RULES_BY_CODE}/${id}`, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @description Cargar acciones y reglas segun el modulo
   */
  getRulerByCode(id): Observable<IRulesByCodeResponse> {
    return this._http
      .get(`${constant.URL_RULES_BY_CODE_V2}/${id}`, this.getHeader())
      .map(res => res.json() as IRulesByCodeResponse)
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @description Cargar acciones y reglas segun el modulo
   */
  getRulerByCodeAndPayor(code, payor): Observable<IRulesByCodeResponse> {
    return this._http
      .get(`${constant.URL_RULES_BY_CODE_AND_PAYOR}/${code}/${payor}`, this.getHeader())
      .map(res => res.json() as IRulesByCodeResponse)
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @description Cargar acciones y reglas segun el modulo
   */
  getRulerByCodeAndPayors(code, payors): Observable<IRulesByCodeResponse[]> {
    return this._http
      .post(`${constant.URL_RULES_BY_CODE_AND_PAYOR}/${code}`, {Ids : payors} , this.getHeader())
      .map(res => res.json() as IRulesByCodeResponse[])
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @description Eliminar una regla
   */
  deleteRuler(id) {
    return this._http
      .delete(`${constant.URL_RULES}/${id}`, this.getHeader())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  postRule(data) {
    return this._http
      .post(constant.URL_RULES, data,  this.headerPost())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  postRuleForPayor(data) {
    return this._http
      .post(constant.URL_RULES_PAYOR, data,  this.headerPost())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  putRuleForPayor(data) {
    return this._http
      .put(constant.URL_RULES_PAYOR, data,  this.headerPost())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  getRuleForPayor(payor, rule) {
    return this._http
      .get(`${constant.URL_RULES_PAYOR}/PayorId/${payor}/verificationRuleId/${rule}`,  this.headerPost())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  putRule(data) {
    return this._http.put(constant.URL_RULES, data, this.headerPost())
      .map(res => res.json())
      .catch((error) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rules/rules.service.ts